import React from 'react'
import PropTypes from 'prop-types'
import { Button, Space, Typography } from 'antd'
import { PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons'
import { contactDigits, telLink, whatsappLink } from './utils'

// The customer's number, unmasked — this screen is staff-only and the whole point of an alert is
// that somebody rings them. Same three controls, and the same WhatsApp brand green, as the duty
// conversation detail page, so the gesture is already learnt.
const ContactButtons = ({ phone, message, size }) => {
  const digits = contactDigits(phone)
  if (!digits) return <span style={{ opacity: 0.65 }}>No contact number</span>

  return (
    <Space wrap size={4}>
      <Typography.Text copyable={{ text: `+${digits}` }}>{`+${digits}`}</Typography.Text>
      <Button size={size} icon={<PhoneOutlined />} href={telLink(phone)}>
        Call
      </Button>
      <Button
        size={size}
        type="primary"
        icon={<WhatsAppOutlined />}
        href={whatsappLink(phone, message)}
        target="_blank"
        rel="noopener noreferrer"
        style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
      >
        WhatsApp
      </Button>
    </Space>
  )
}

ContactButtons.propTypes = {
  phone: PropTypes.string,
  message: PropTypes.string,
  size: PropTypes.string
}

ContactButtons.defaultProps = { size: 'small' }

export default ContactButtons
